








































import Vue from 'vue';
import { mapGetters } from 'vuex';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';

export default Vue.extend({
  components: {
    pxCard,
    pxButton,
  },
  data() {
    return {
      creating: false,
      pushing: false,
    };
  },
  computed: {
    ...mapGetters({
      examModeById: 'examModeById',
    }),
    examMode() {
      const examModeId = +this.$route.params.examModeId;
      return this.examModeById(examModeId);
    },
    name: {
      get() {
        return this.examMode.name;
      },
      set(value: string) {
        if (this.examMode.id) {
          this.$store.commit('UPDATE_ENTITY_PROP', {
            id: this.examMode.id,
            entity: 'exam_modes',
            propToUpdate: 'name',
            value,
          });
        } else {
          this.createExamMode(value);
        }
      },
    },
    description: {
      get() {
        return this.examMode.description;
      },
      set(value: string) {
        this.$store.commit('UPDATE_ENTITY_PROP', {
          id: this.examMode.id,
          entity: 'exam_modes',
          propToUpdate: 'description',
          value,
        });
      },
    },
  },
  created: function() {
    const examModeId = +this.$route.params.examModeId;
    if (examModeId) {
      this.$store.dispatch('PULL_EXAM_MODE', examModeId);
    }
  },
  methods: {
    createExamMode: async function(name: string) {
      const examModeId = await this.$store.dispatch('CREATE_EXAM_MODE', name);
      this.$router.push(`/editar_formato/${examModeId}`);
    },
    pushExamMode: async function() {
      this.pushing = true;
      try {
        await this.$store.dispatch('PUSH_EXAM_MODE_BY_ID', this.examMode.id);
      } catch (e) {
        alert(
          `Algo deu errado. Envie essas informações para os desenvolvedores: ${e}`,
        );
      }
      this.pushing = false;
    },
    deleteExamMode: async function() {
      if (confirm('Tem certeza que deseja deletar esse formato de questão?')) {
        try {
          await this.$store.dispatch('DELETE_EXAM_MODE', this.examMode.id);
        } catch (e) {
          alert(
            `Algo deu errado. Envie essas informações para os desenvolvedores: ${e}`,
          );
        }
      }
    },
  },
});
